import { VAvatar } from 'vuetify/lib/components/VAvatar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAvatar,{staticClass:"mt-3",attrs:{"size":"100"}},[_c('img',{attrs:{"src":_vm.image
        ? _vm.currentImageOriginal
        : ("https://ui-avatars.com/api/?name=" + _vm.name + "&size=64"),"contain":"","aspect-ratio":"1"}})])}
var staticRenderFns = []

export { render, staticRenderFns }